import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { LanguageProvider } from '@/contexts/LanguageContext';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { BackToTop } from '@/components/BackToTop';
import { ChatAgent } from '@/components/ChatAgent';
import { Home } from '@/pages/Home';
import { Services } from '@/pages/Services';
import { Projects } from '@/pages/Projects';
import { Industries } from '@/pages/Industries';
import { About } from '@/pages/About';
import { Contact } from '@/pages/Contact';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <HashRouter>
          <div className="flex flex-col min-h-screen">
            <Header />
            <main className="flex-1 mt-14">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/projets" element={<Projects />} />
                <Route path="/industries" element={<Industries />} />
                <Route path="/secteurs" element={<Industries />} />
                <Route path="/about" element={<About />} />
                <Route path="/a-propos" element={<About />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </main>
            <Footer />
            <BackToTop />
            <ChatAgent />
            <Toaster />
          </div>
        </HashRouter>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;